import React, { useState } from 'react'
import { EVENT_STATUSES } from '../Tables/Events'
// import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { getEvents, SET_EVENT_RED_STATUS } from 'redux/modules/events/actions'
import { getEventsPagination, getFilterEvents } from 'redux/selectors/events'
import moment from 'moment-timezone'
import { useFormik } from 'formik'

// const event = {
//   status: 'finished',
//   statusStart: '2025-02-12T13:43:13.229268',
//   statusEnd: '2025-09-01T17:43:20.229268',
//   staging: {
//     1: {
//       status: 'created',
//       success: false
//     },
//     2: {
//       status: 'pending',
//       success: true
//     },
//     3: {
//       status: 'pending_patient',
//       success: true
//     },
//     4: {
//       status: 'medcard',
//       success: true
//     },
//     5: {
//       status: 'finished',
//       success: false,
//       message: 'Качество консультации врачом 🔥'
//     }
//   }
// }

const TZ = 'Asia/Bishkek'
// const TZ = 'Europe/Moscow'

const EventStatusText = ({ event }) => {
  const currentStageValue = React.useMemo(() => {
    for (let key in EVENT_STATUSES) {
      if (key === event.status) {
        return key.toString()
      }
    }
    return 'created'
  }, [event.status, event.staging, event.id])

  const renderText = () => {
    const message =
      event.staging[EVENT_STATUSES[currentStageValue] ?? 'created'].message
    if (message) {
      return message
    }

    switch (currentStageValue ?? 'create') {
      case 'created':
        return 'Подтвердите прием у врача'

      case 'pending':
        return 'Ожидается начало приема'

      case 'pending_doctor':
        return 'Подключите врача'

      case 'pending_patient':
        return 'Подключите пациента'

      case 'during':
        return 'Приём идет'

      case 'medcard':
        return 'Врач должен заполнить медкарту'

      case 'grade':
        return 'Оцените качество приема'

      case 'rate':
        return 'Приём завершен'

      case 'cancelled':
        return 'Приём отменен'

      default:
        return 'Статус не определен'
    }
  }

  const dispatch = useDispatch()
  const eventsPagination = useSelector(getEventsPagination)
  const filterEvents = useSelector(getFilterEvents)

  const fetchEvents = (
    page = eventsPagination.page,
    newCount = eventsPagination.perPage
  ) => {
    if (newCount === 9999) newCount = eventsPagination.perPage
    dispatch(
      getEvents(
        { filter: filterEvents },
        () => {},
        () => {},
        { page, count: newCount || eventsPagination.perPage }
      )
    )
  }

  // безопасно парсим даты
  const start = React.useMemo(() => {
    if (!event?.statusStart) return null
    const m = moment.tz(event.statusStart, TZ)
    return m.isValid() ? m : null
  }, [event?.statusStart])

  const end = React.useMemo(() => {
    if (!event?.statusEnd) return null
    const m = moment.tz(event.statusEnd, TZ)
    return m.isValid() ? m : null
  }, [event?.statusEnd])

  // показываем таймер только если обе даты валидны, сегодня та же дата, и сейчас внутри интервала
  const isShowTimer = React.useMemo(() => {
    if (!start || !end || event.staging[event.stage].success === false)
      return false
    const now = moment.tz(TZ)
    return (
      now.format('YYYY-MM-DD') === end.format('YYYY-MM-DD') &&
      now.isBetween(start, end)
    )
  }, [start, end, event.status, event.staging])

  // состояние оставшегося времени
  const [msLeft, setMsLeft] = useState(0)

  // при смене дат — пересчитать остаток
  React.useEffect(() => {
    if (!end) {
      setMsLeft(0)
      return
    }
    const now = moment.tz(TZ)
    const diff = end.diff(now, 'milliseconds')
    setMsLeft(diff > 0 ? diff : 0)
  }, [end])

  // тикер: считаем каждый раз от "сейчас"
  React.useEffect(() => {
    if (!isShowTimer || !end) return
    const id = setInterval(() => {
      const now = moment.tz(TZ)
      const diff = end.diff(now, 'milliseconds')
      const next = diff > 0 ? diff : 0
      setMsLeft(next)
      if (next === 0) {
        clearInterval(id)
        dispatch({
          type: SET_EVENT_RED_STATUS,
          payload: {
            id: event.id
          }
        })
        // fetchEvents()
      }
    }, 1000)
    return () => clearInterval(id)
  }, [isShowTimer, end]) // важно: завись от end

  const minutes = Number.isFinite(msLeft) ? Math.floor(msLeft / 60000) : 0
  const seconds = Number.isFinite(msLeft)
    ? Math.floor((msLeft % 60000) / 1000)
    : 0
  const pad = (n) => (n < 10 ? `0${n}` : String(n))

  return (
    <>
      {`${renderText()} `}
      {isShowTimer ? `(${minutes}:${pad(seconds)})` : ''}
    </>
  )
}

export default EventStatusText
